import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CatalogRouterModule } from './catalog-router.module';
import { CatalogDetailComponent } from './catalog-detail/catalog-detail.component';
import { RecommendSliderComponent } from './recommend-slider/recommend-slider.component';
import { CatalogSectionComponent } from './catalog-section/catalog-section.component';
import { CatalogSectionItemsComponent } from './catalog-section-items/catalog-section-items.component';
import { CatalogSectionFilterComponent} from './catalog-section-filter/catalog-section-filter.component';
import { CatalogPromoSliderComponent} from './catalog-promo-slider/catalog-promo-slider.component';
import { CatalogFilterTagsComponent} from './catalog-filter-tags/catalog-filter-tags.component';
import { CatalogService } from './catalog.service';
import { TouchspinModule } from '../touchspin/touchspin.module';
import { PaginationModule } from '../pagination/pagination.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CatalogRouterModule,
    TouchspinModule,
    PaginationModule,
  ],
  declarations: [
    CatalogSectionComponent,
    CatalogSectionItemsComponent,
    CatalogSectionFilterComponent,
    CatalogDetailComponent,
    CatalogFilterTagsComponent,
    RecommendSliderComponent,
    CatalogPromoSliderComponent,
  ],
  providers: [
    CatalogService,
  ]
})
export class CatalogModule {}
